module.exports = __webpack_public_path__ + "img/banner-kai-mobile.d6112fea.png";